import { AxiosRequestConfig, AxiosResponse } from 'axios'

import { useCallback, useState } from 'react'

import { ApiFuncParam, ApiRunPromiseFunc, ApiPromiseFuncOutput } from '@/modules'

import { useBaseAPI } from './baseApi.hook'
import { buildUrlRequest } from '@/utils'

export type PromiseQueryOutput<T> = [ApiRunPromiseFunc<T>, boolean, () => void]

export function usePromiseQuery<T>(url: string): PromiseQueryOutput<T> {
  const { instance, canceler } = useBaseAPI()

  const [isPending, setPending] = useState<boolean>(false)

  const run = useCallback(
    async (urlParams?: ApiFuncParam | string, queryParams?: ApiFuncParam): Promise<ApiPromiseFuncOutput<T>> => {
      const config: AxiosRequestConfig = {}

      if (queryParams) {
        config.params = queryParams
      }

      const urlRequest = buildUrlRequest(url, urlParams)

      setPending(true)

      try {
        const response: AxiosResponse<T> = await instance.get(urlRequest, config)
        setPending(false)
        return [response?.data, undefined, canceler.abort]
      } catch (error: any) {
        setPending(false)
        return [undefined, error, canceler.abort]
      }
    },
    [instance, url, canceler],
  )

  return [run, isPending, canceler.abort]
}
